import React from "react";

// Circular score ring 0-100 with color coding
export default function ScoreRing({ value = 0, size = 120, stroke = 10, color, label, sub }) {
  const clamped = Math.max(0, Math.min(100, value));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (clamped / 100) * c;

  const ringColor =
    color ||
    (clamped >= 75 ? "var(--meter-excellent)" : clamped >= 50 ? "var(--meter-good)" : "var(--meter-poor)");

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90 absolute inset-0">
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke="rgba(255,255,255,0.08)"
            strokeWidth={stroke}
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke={ringColor}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 1s cubic-bezier(0.2,0.7,0.2,1)" }}
          />
        </svg>
        <div className="absolute inset-0 pointer-events-none flex flex-col items-center justify-center">
          <div className="metric-value text-3xl text-white">{Math.round(clamped)}</div>
          {sub && <div className="tiny-caps text-[10px] opacity-60 mt-0.5">{sub}</div>}
        </div>
      </div>
      {label && <div className="tiny-caps mt-1">{label}</div>}
    </div>
  );
}
